import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
    setLoginInfo(state, data) {
        state.userInfo = data;
    },
}